namespace Matrix.Data {
    export class DataReportsColumns {
        static columnsKey = 'Data.DataReports';
    }
}
